import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@env/environment';
import { map, mergeMap, Observable, of, retryWhen } from 'rxjs';

import { Credentials, CredentialsService } from './credentials.service';
import { genericRetryStrategy } from '@app/shared/utils';
import { Response } from './interfaces/response.interface';


export interface LoginContext {
  NumberCert: string;
  Birthday: string;
  remember?: boolean;
}

/**
 * Provides a base for authentication workflow.
 * The login/logout methods should be replaced with proper implementation.
 */
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private credentialsService: CredentialsService, private http: HttpClient) {}

  /**
   * Authenticates the user.
   * @param context The login parameters.
   * @return The user credentials.
   */

  getAuthToken(): Observable<any> {
    const key_api = {
      KeyAccess: environment.keyAccessToken,
      flag: environment.flagToken,
    };
    return this.http.post<any>('/access/token', key_api);
  }

  hasToken(): boolean {
    return !!localStorage.getItem('token');
  }

  obtenerToken() {
    return localStorage.getItem('token');
  }

  login(context: LoginContext): Observable<Response<Credentials>> {
    const data = {
      NumberCert: context.NumberCert,
      Birthday: context.Birthday,
    };

    return this.http.post<Response<Credentials>>(
      '/refund/Refund/SendLoginOdoo',
      data
    );
  }

  /**
   * Logs out the user and clear credentials.
   * @return True if the user was logged out successfully.
   */
  logout(): Observable<boolean> {
    // Customize credentials invalidation here
    this.credentialsService.setCredentials();
    return of(true);
  }

  checkAuth(credential: Credentials, context: LoginContext): Credentials | null {
    console.log(
      '🚀 ~ file: authentication.service.ts ~ line 69 ~ AuthenticationService ~ checkAuth ~ credential',
      credential
    );
    if (credential.birthDate.indexOf(context.Birthday) < 0) {
      return null;
    }

    this.credentialsService.setCredentials(credential, context.remember);
    return credential;
  }
}
